<template>
  <div class="content_menu clearfix">
    <div class="left" style="width:343px">
      <div class="left" style="width:178px;">
        <TheFoodMenu active="shakes" />
      </div>

      <div class="left" style="margin:0px 0 0 27px;">
        <img src="/assets/images/titles/menu_left_shakes.png" />
      </div>

      <br clear="all" />
    </div>

    <div class="right" style="width:552px; margin:8px 0px 0 0;">
      <div class="left" style="width:522px; height:117px;">
        <img src="/assets/images/menu_img/shakes.png" />
      </div>

      <br clear="all" />

      <div class="product-container">
        <ProductList :products="products" />

        <br clear="all" />

        <div class="left" style="margin:30px 0 0 -60px;">
          <img src="/assets/images/menu_img/menu_img6.2.png" />
        </div>
      </div>

      <div class="menu_right">
        <div class="right" style="margin:-116px 14px 0 0;">
          <img src="/assets/images/menu_img/menu_right_shakes.png" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TheFoodMenu from '@/components/TheFoodMenu.vue';
import ProductList from '@/components/ProductList.vue';

export default {
  name: 'Shakes',

  components: {
    TheFoodMenu,
    ProductList,
  },

  data() {
    return {
      products: [
        {
          id: 1,
          name: 'MILK SHAKES',
          description: 'Old Fashioned Shakes made with locally made premium ice cream',
          modifiers: [
            {
              description: 'Vanilla, Strawberry, Chocolate',
            },
            {
              description: 'Oreo, Coffee, Green Mint Chocolate Chip',
            },
          ],
        },
        {
          id: 2,
          name: 'ROOT BEER FLOAT',
          description: 'Made with Thomas Kemper hand crafted root beer',
          modifiers: [],
        },
      ],
    };
  },
};
</script>
